import * as Sentry from '@sentry/react';
import appEnv from 'app/config/appEnv';

Sentry.init({
  dsn: 'https://c27c998d0007c1397b91efd07c9c95df@o4510125815103488.ingest.de.sentry.io/4510142612635728',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: appEnv.VITE_ENV,
});

export default Sentry;
